export default __webpack_public_path__ + "static/media/portfoliomain.91404c2f.PNG";